const Gauage = {
    chart: {
        type: 'gauge',
        width: 260,
        height: 210,
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        borderRadius: 8,
        marginBottom: -40,
        marginTop:0
    },
    title: {
        enabled: false,
        text: null
    },
    exporting: {
        enabled: false
    },
    legend: {
        enabled: false
    },
    pane: {
        startAngle: -110,
        endAngle: 110,
        size: '85%',
        background: [{
            backgroundColor: '#fff',
            borderWidth: 0,
            // default background
        }]
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        gauge: {
            //arrow
            dial: {
                radius: '120%',
                backgroundColor: '#3D3D3D',
                baseWidth: 20,
                borderWidth: 2.5,
                borderColor: "#fff",
                topWidth: 0,
                baseLength: '75%', // of radius
                rearLength: '-75%',

            },
            pivot: {
                radius: 0,
                backgroundColor: 'gray'
            }
        }
    },
    // the value axis
    yAxis: {
        min: 0,
        max: 100,
        tickPosition: 'inside',
        tickColor: '#666',
        tickLength: 10,
        tickWidth: 0,
        minorTickWidth: 3,
        minorTickColor: '#fff',
        minorTickPosition: 'inside',
        minorTickLength: 0,
        minorTickInterval: null,
        offset: 10,
        lineWidth: 0,
        tickAmount: 2,
        labels: {
            y: 20,
            distance: -10,
            style: {
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#808080'
            }
        },
        endOnTick: false,
        plotBands: [{
            from: 0,
            to: 32.5,
            innerRadius: '95%',
            outerRadius: '110%',
            color: '#FB656E',
        }, {
            from: 33.5,
            to: 66,
            innerRadius: '95%',
            outerRadius: '110%',
            color: '#FCBC5B'
        }, {
            from: 67,
            to: 100,
            innerRadius: '95%',
            outerRadius: '110%',
            color: '#64EE9C'
        }]
    },

    series: [{
        // animation: false,
        name: 'Speed',
        data: [{y:80.5, name:80.5}],
        dataLabels: {
            formatter: function () {
                return this.point.name
            },
            y: -55,
            borderColor: "#fff",
            style: {
                fontFamily: "Stolzl-Medium",
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: 36,
                lineHeight: '40px',
                color: '#3D3935'
            }
        }
    }]
}
export default Gauage;
